export const PARTNERS_EMAIL = "support@tutor.peardeck.com";
export const K12_RESOURCES =
  "https://view.highspot.com/viewer/1a792572ae0bcc3f8c8cd2d161f59578";
export const HIGHER_ED_RESOURCES =
  "https://view.highspot.com/viewer/d0014994d3dd5f383c1a56ed38b3c12d";

export const getResourcesLink = (partnerType?: string | null) => {
  return partnerType === "k-12" ? K12_RESOURCES : HIGHER_ED_RESOURCES;
};
